import type React from "react";
import { useId } from "react";

const RuterLogo: React.FC = () => {
	const id = useId();
	return (
		<svg
			data-test-id="ruter-logo"
			height="1rem"
			width="5rem"
			fill="rgb(230, 0, 0)"
			viewBox="0 0 1200 258"
			role="img"
			aria-labelledby={id}
		>
			<title id={id}>Ruter logo</title>
			<path d="M1192.35 98.4l7.65-39.34h-62l11.47-59h-41.3l-11.47 59h-62l11.47-59h-41.32l-11.46 59h-62l-7.53 39.34h62l-11.47 59h-62l-7.64 39.33h62l-11.47 59h41.31l11.47-59h62l-11.48 59h41.32l11.47-59h62l7.64-39.33h-62l11.47-59zm-114.73 59h-62l11.48-59h61.95zM135.71 255.62l-49.91-102H49.9v102H0V0h100.16c52.06 0 82.94 35.54 82.94 78.26 0 35.91-21.9 58.16-46.67 67.14l57.08 110.22zM96.94 44.52h-47V112h47c21.89 0 36.25-14 36.25-33.75s-14.36-33.73-36.25-33.73zM334.66 255.62v-17.24c-12.2 12.92-29.43 19.38-46.67 19.38-18.67 0-33.75-6.1-44.16-16.51-15.08-15.08-19-32.66-19-53.13V68.57h46.67v113.08c0 25.5 16.16 34.11 30.87 34.11s31.23-8.61 31.23-34.11V68.57h46.67v187.05zM491.2 255.62c-38.06 0-54.21-26.93-54.21-53.5v-98.28h-19.75V68.3H437V18.67h46.67V68.3h33v35.54h-33v95.4c0 10.78 5 16.88 16.15 16.88h16.87v39.5zM594.52 176.63c0 24.05 14.73 41.64 40.93 41.64 20.47 0 30.52-5.74 42.37-17.59l28.36 27.65c-19 19-37.34 29.43-71.09 29.43-44.15 0-86.52-20.1-86.52-95.85 0-61 33-95.49 81.5-95.49 52 0 81.49 38.05 81.49 89.39v20.82zm66.78-52.06c-5-11.13-15.44-19.38-31.23-19.38s-26.21 8.25-31.23 19.38c-2.88 6.83-4 11.85-4.32 20.1h71.09c-.36-8.25-1.44-13.27-4.31-20.1zM875.27 72.81c-8.57-4.56-17.93-6.39-29.42-6.39-20.1 0-38.05 9.33-47 20.1v-18h-45.62v187.1h46.67V142.88c0-23.69 15.85-33.08 30.16-34.46 17-1.64 26.33 7 26.33 7z" />
		</svg>
	);
};

export default RuterLogo;
